import script from "./TestimonialCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialCarousel.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialCarousel.vue?vue&type=style&index=0&id=b2e612de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2e612de"]])

export default __exports__